import l10n from '../../lib/reactPPl10nHelper';
import i18n from '../../lib/reacti18n';

const prompt = {
  smc: l10n.getContent('smarthelp/prompt.logout.smc'),
  nonSmc: l10n.getContent('smarthelp/prompt.logout.noSmc'),
  second: l10n.getContent('smarthelp/prompt.second'),
  first: l10n.getContent('smarthelp/prompt.login.first'),
  logoutButton: l10n.getContent('smarthelp/prompt.logout.button'),
  loginButton: l10n.getContent('smarthelp/prompt.login.button'),
  emailButton: l10n.getContent('smarthelp/prompt.email.button'),
  nnaSubTitle: i18n.message('smarthelp/home.home.NNA.welcomeSetupGuideMessage'),
  getStarted: i18n.message('smarthelp/home.home.getStarted'),
};

export default prompt;
